import axios from 'axios';
import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import CustomSnackbar from '../@extended/CustomSnackbar';
import { config } from '../../env';
import { useLocation, useNavigate } from 'react-router-dom';

const ENV_NAME = config.env_name;

let localMaintenance = localStorage.getItem('CURRENT_MAINTENANCE_' + ENV_NAME);

const AppVersionChecker = () => {
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState('');
  const location = useLocation();
  const [isValidPath, setIsValidPath] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const tmpPath = location.pathname;
    if (
      tmpPath === '/' ||
      tmpPath.includes('/login') ||
      tmpPath.includes('/register') ||
      tmpPath.includes('/forgot-password') ||
      tmpPath.includes('/check-mail') ||
      tmpPath.includes('/welcome')
    ) {
      setIsValidPath(false);
    } else {
      setIsValidPath(true);
    }
  }, [location]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [localVersion, setLocalVersion] = useState<string | null>(() => {
    return localStorage.getItem('CURRENT_VERSION_' + ENV_NAME);
  });

  const { user } = useAuth();
  const fetchVersion = () => {
    setLoading(true);
    axios
      .get('https://traders-connect.github.io/frontend-app-versions/')
      .then((res) => {
        const tmpVersion = res.data[ENV_NAME + '_version'];
        const tmpMaintenance = res.data[ENV_NAME + '_under_maintenance'];
        setVersion(tmpVersion);
        if (localVersion === null) {
          localStorage.setItem('CURRENT_VERSION_' + ENV_NAME, tmpVersion);
          setLocalVersion(tmpVersion);
        }
        if (tmpMaintenance === true) {
          localStorage.setItem('CURRENT_MAINTENANCE_' + ENV_NAME, 'true');
          localMaintenance = 'true';
          navigate('maintenance', { replace: true });
        } else {
          if (localMaintenance?.toUpperCase() === 'TRUE') {
            localStorage.setItem('CURRENT_MAINTENANCE_' + ENV_NAME, 'false');
            localMaintenance = 'false';
            navigate('dashboard', { replace: true });
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('ERROR: ', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchVersion();
    }, config.version_checking_interval);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    fetchVersion();
  }, []);
  return (
    <>
      {!loading && isValidPath && version !== localVersion && (
        <CustomSnackbar
          action={true}
          duration={-1}
          open={true}
          message={'New version available'}
          buttonName={'Update'}
          handleButton={() => {
            localStorage.setItem('CURRENT_VERSION_' + ENV_NAME, version);
            window.location.reload();
          }}
          alert={{
            color: 'error'
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transition={'SlideUp'}
        />
      )}
    </>
  );
};

export default AppVersionChecker;
